import Box from '@mui/material/Box';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import React from 'react';

const StoryblokCarouselReviewSlide = ({ blok }) => {
  const { review } = blok;

  const hasReview = review && review.length > 0;
  if (!hasReview) return null;

  return (
    <Box {...storyblokEditable(blok)} key={blok._uid}>
      <StoryblokComponent blok={review[0]} key={review[0]._uid} />
    </Box>
  );
};

export default StoryblokCarouselReviewSlide;
